<template>
  <div class="main">
    <iframe
      width="100%"
      height="100%"
      id="mainframe"
      frameborder="no"
      scrolling="no"
      allowfullscreen
      title="Inline Frame Example"
      allow="microphone"
      :src="`https://ll-livespeaking.liveabc.com/AIStorybook/maker?uuid=${$route.params.bookId}&token=${$store.state.auth.user.token}` ">
    </iframe>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'ModifyBook',
  data () {
    return {
      books: {}
    }
  },
  created () {

  },
  mounted () {
    const iframe = document.getElementById('mainframe')
    window.addEventListener('message', (event) => {
      if (event.data < window.innerHeight) {
        iframe.style.height = window.innerHeight + 'px'
      } else {
        iframe.style.height = event.data + 150 + 'px'
      }
    })
  },
  beforeDestroy () {
    const iframe = document.getElementById('mainframe')
    window.removeEventListener('message', (event) => {
      iframe.style.height = event.data + 'px'
    })
  },
  methods: {
  },
  components: {
    // Video
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #mainframe {
    min-height: 900px;
  }

</style>
